import Vue from "vue";
import CompanyService from "@/service/company-service";
import uuid from "uuid";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import { zLanguageChanger } from "zoox-components";
import { ReservationService } from "smck-service";
import { CustomHeadersService } from "zoox-infra";

export default {
  name: "Success",
  mixins: [sessionMixin],
  components: {
    "z-language-changer": zLanguageChanger
  },
  data() {
    return {
      customLogo: "",
      companyService: new CompanyService(),
      reservationService: new ReservationService(Vue),
      openGuestSelect: false,
      requestReady: false,
      customMessages: {},
      reservationId: this.$route.params.reservationId,
      reservation: {}
    };
  },
  created() {
    // sempre que entramos na tela, damos scroll para o topo
    // pois por vezes o scroll vem alterado da tela anterior
    $(document).ready(function() {
      $(this).scrollTop(0);
    });
  },
  computed: {
    customMessage: function() {
      const currentLang = this.$i18n.locale;

      return (
        this.customMessages[`message_${currentLang}`] ||
        this.customMessages[`message_en`] ||
        this.customMessages["message"]
      );
    }
  },
  mounted() {
    this.$resetState();
    CustomHeadersService.removeCustomHeadersKey("Authorization");
    const company = this.companyService.getLocalCompany();
    const customizationSettings = this.companyService.getLocalCustomizationSettings();
    if (customizationSettings && customizationSettings.portalLogoUrl) {
      this.customLogo = customizationSettings.portalLogoUrl;
    }

    if (company && company.id) {
      this.companyService.getFnrhMessageSettings(company.id).then(resp => {
        this.customMessages = resp;

        this.requestReady = true;
      });

      if (this.reservationId) {
        this.getReservation(this.reservationId).then(resp => {
          this.reservation = resp;
        });
      }
    }
  },
  methods: {
    getCustomLogo: function() {
      return this.customLogo
        ? this.customLogo + `?unique=${uuid.v4()}`
        : require("@/assets/images/placeholder.png");
    },
    getReservation: function(reservationId) {
      const $context = this;
      return $context.reservationService.getOne(reservationId);
    },
    cardClick: function(reservationId, guestId) {
      this.$redirectGuestView(reservationId, guestId);
    },
    openModal: function() {
      this.openGuestSelect = true;
    },
    cancelModal: function() {
      this.openGuestSelect = false;
    },
    getFullName: function(guest) {
      return `${guest.name} ${guest.lastName}`;
    },
    getPhotoUrl: function(guest) {
      return (
        guest.photoUrl || require("../../../assets/images/generic-user.jpg")
      );
    }
  }
};
